export default (function (arr) { return arr.slice(0, -1); });



//////////////////
// WEBPACK FOOTER
// ./~/@reecelucas/react-use-hotkeys/esm/helpers/takeUntilLast.js
// module id = 665
// module chunks = 0